module.exports = "/static/assets/3083b04e2b7ff42d5cb2d801e37d99b9.svg";